import React from 'react';

import { WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import type { BlockText } from '../../../types/uncinc_profile/blocks';

export interface CtaBlockProps {
  entity: ImmutableEntity<BlockText>;
}

const TextBlock: React.FC<CtaBlockProps> = ({
  entity,
}) => (
  <WysiwygField
    property="schema:text"
    className="TextBlock"
    html={entity.getIn(['body', 0, 'processed'])}
  />
);

export default TextBlock;
